import React, { useState, useEffect, useRef } from "react";
import { withGoogleMap, withScriptjs, GoogleMap, Polyline, Marker } from "react-google-maps";
import { GOOGLE_MAPS_API_KEY } from "../../config/Constant";
import { fetchLiveLocation } from "../../services/auth.service";
import { useSelector } from 'react-redux';
import { jobId } from "../../slice/commonSlice";
import carImg from "../../assets/images/live_tracking_mark.png"

const LiveTracking = ({ startLocation, endLocation, lastStatus }) => {
  const [vehicleLocation, setVehicleLocation] = useState(startLocation);
  const [directions, setDirections] = useState(null);
  const mapRef = useRef(null);
  let id = useSelector(jobId);
  useEffect(() => {
    const intervalId = setInterval(() => {
      if(lastStatus !== 'delivered'){
        getLiveLocation();
      }
      // const newVehicleLocation = {
      //   lat: startLocation.lat + (Math.random() - 0.5) * 0.01,
      //   lng: startLocation.lng + (Math.random() - 0.5) * 0.01,
      // };


      // setVehicleLocation(newVehicleLocation);
      // setPath((prevPath) => [...prevPath, newVehicleLocation]);
    }, 5000);

    return () => clearInterval(intervalId); // Cleanup the interval on component unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startLocation]);

  const getLiveLocation = async () => {

    let payload = {
        "jobId": id
    }
    try {
        const response = await fetchLiveLocation(payload);
        if(response?.data?.status){
          if(response?.data?.lat && response?.data?.long){
            setVehicleLocation({
              lat: response?.data?.lat,
              lng: response?.data?.long
            });
          }else{
            setVehicleLocation(startLocation)
          }
        }
    } catch (error) {
        console.error("Error fetching data:", error);
    }
}
  useEffect(() => {
    // Fetch driving directions when component mounts or when start/end locations change
    const directionsService = new window.google.maps.DirectionsService();
    const origin = new window.google.maps.LatLng(startLocation.lat, startLocation.lng);
    const destination = new window.google.maps.LatLng(endLocation.lat, endLocation.lng);

    directionsService.route(
      {
        origin,
        destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirections(result.routes[0].overview_path);
        } else {
          console.error("Error fetching directions:", status);
        }
      }
    );
  }, [startLocation, endLocation]);

  useEffect(() => {
    if (mapRef.current && directions && vehicleLocation) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(new window.google.maps.LatLng(vehicleLocation.lat, vehicleLocation.lng));
      directions.forEach((point) => bounds.extend(point));
      mapRef.current.fitBounds(bounds, { padding: 50 });
    }
  }, [directions, vehicleLocation]);

  const icon = {
    // url: "https://images.vexels.com/media/users/3/154573/isolated/preview/bd08e000a449288c914d851cb9dae110-hatchback-car-top-view-silhouette-by-vexels.png",
    url:carImg,
    scaledSize: new window.google.maps.Size(30, 30),
    anchor: { x: 15, y: 15 },
  };

  const originMarker = <Marker key="origin" position={startLocation} label="A" />;
  const destinationMarker = <Marker key="destination" position={endLocation} label="B" />;

  return (
    <GoogleMap ref={mapRef} defaultCenter={startLocation} defaultZoom={12}>
      {originMarker}
      {destinationMarker}
      {vehicleLocation && <Marker icon={icon} position={vehicleLocation} />}
      {/* {path.length > 1 && destinationMarker && (
        <Polyline
          path={path}
          options={{
            strokeColor: "blue",
            strokeWeight: 10,
            strokeOpacity: 0.4,
          }}
        />
      )} */}
      {directions && destinationMarker && (
        <>
          <Polyline
            path={directions}
            options={{
              strokeColor: "blue",
              strokeWeight: 10,
              strokeOpacity: 0.5,
            }}
          />
        </>
      )}
    </GoogleMap>
  );
};

const MapComponent = withScriptjs(withGoogleMap(LiveTracking));

const LiveTrackingMap = ({ startLocation, endLocation }) => (
  <MapComponent
    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
    loadingElement={<div style={{ height: `100%` }} />}
    containerElement={<div style={{ height: `400px`, width: "100%" }} />}
    mapElement={<div style={{ height: `100%` }} />}
    startLocation={startLocation}
    endLocation={endLocation}
  />
);

export default LiveTrackingMap;
